import HomeAccount from '@mdi/svg/svg/home-account.svg';
import CashMultiple from '@mdi/svg/svg/cash-multiple.svg';
import AccountMultiple from '@mdi/svg/svg/account-multiple.svg';
import Atom from '@mdi/svg/svg/atom.svg';
import UnfoldMoreVertical from '@mdi/svg/svg/unfold-more-vertical.svg';
import DesktopTowerMonitor from '@mdi/svg/svg/desktop-tower-monitor.svg';
import ChartAreaspline from '@mdi/svg/svg/chart-areaspline.svg';
import HardHat from '@mdi/svg/svg/hard-hat.svg';
import BrightnessPercent from '@mdi/svg/svg/brightness-percent.svg';
import Bank from '@mdi/svg/svg/bank.svg';
import FaceAgent from '@mdi/svg/svg/face-agent.svg';


const icons = {
  homeAccount: HomeAccount,
  cashMultiple: CashMultiple,
  accountMultiple: AccountMultiple,
  atom: Atom,
  unfoldMoreVertical: UnfoldMoreVertical,
  desktopTowerMonitor: DesktopTowerMonitor,
  chartAreaspline: ChartAreaspline,
  hardHat: HardHat,
  brightnessPercent: BrightnessPercent,
  bank: Bank,
  faceAgent: FaceAgent,
  'mdi mdi-home-account': HomeAccount,
  'mdi mdi-cash-multiple': CashMultiple,
  'mdi mdi-account-multiple': AccountMultiple,
  'mdi mdi-atom': Atom,
  'mdi mdi-unfold-more-vertical': UnfoldMoreVertical,
  'mdi mdi-desktop-tower-monitor': DesktopTowerMonitor,
  'mdi mdi-chart-areaspline': ChartAreaspline,
  'mdi mdi-hard-hat': HardHat,
  'mdi mdi-brightness-percent': BrightnessPercent,
  'mdi mdi-bank': Bank,
  'mdi mdi-face-agent': FaceAgent
};

export default icons;